import { EMPTY_LIST, EMPTY_OBJECT } from '../../../constants/common'
import { Widget } from '../Widget'
import { WidgetFormContainer } from '../WidgetFormContainer'
import { WidgetHeaderContentActionsAddButton } from '../WidgetHeaderContentActionsAddButton'

import { ProfileResponsibleManagersWidgetContent } from './ProfileResponsibleManagersWidgetContent'

function ProfileResponsibleManagersWidget({
  addButtonProps,
  canEdit = false,
  contentContainerProps = EMPTY_OBJECT,
  formProps,
  isSkeleton,
  items = EMPTY_LIST,
  listProps,
  title,
  widgetProps,
}) {
  const hasManagers = items?.length > 0

  const headerProps = {
    ...widgetProps?.headerProps,
    contentProps: {
      ...widgetProps?.headerProps?.contentProps,
      actionsProps: {
        ...widgetProps?.headerProps?.contentProps?.actionsProps,
        ...(canEdit
          ? hasManagers
            ? {
                AdditionalActions: WidgetHeaderContentActionsAddButton,
                EditButton: null,
                additionalActionsProps: addButtonProps,
              }
            : {
                AddButton: WidgetHeaderContentActionsAddButton,
                EditButton: null,
                ExpandButton: null,
                addButtonProps,
              }
          : {
              AddButton: null,
              EditButton: null,
            }),
      },
    },
  }

  return (
    <Widget
      {...widgetProps}
      contentContainerProps={contentContainerProps}
      headerProps={headerProps}
      isSkeleton={isSkeleton}
      title={title}
    >
      <ProfileResponsibleManagersWidgetContent
        formProps={{
          FormContainer: WidgetFormContainer,
          ...formProps,
        }}
        items={items}
        listProps={listProps}
      />
    </Widget>
  )
}

export default ProfileResponsibleManagersWidget
